import { makeEventFunctions } from '@deephaven/golden-layout';
import { InputFilterEvent } from "./events/index.js";
var filterColumnsChangedFns = makeEventFunctions(InputFilterEvent.COLUMNS_CHANGED);

/**
 * Listen for filter column changes
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the columns
 * @param columns The columns available for filtering or null to remove the filter for the sourceId
 */
export var listenForFilterColumnsChanged = filterColumnsChangedFns.listen;

/**
 * Emit a filter columns changed event
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the columns
 * @param columns The columns available for filtering or null to remove the filter for the sourceId
 */
export var emitFilterColumnsChanged = filterColumnsChangedFns.emit;

/**
 * Use a filter columns change event listener
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the columns
 * @param columns The columns available for filtering or null to remove the filter for the sourceId
 */
export var useFilterColumnsChangedListener = filterColumnsChangedFns.useListener;
var filterTableChangedFns = makeEventFunctions(InputFilterEvent.TABLE_CHANGED);

/**
 * Listen for filter table changes
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the table
 * @param table The table available for filtering or null to remove the table for the sourceId
 */
export var listenForFilterTableChanged = filterTableChangedFns.listen;

/**
 * Emit a filter table changed event
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the table
 * @param table The table available for filtering or null to remove the table for the sourceId
 */
export var emitFilterTableChanged = filterTableChangedFns.emit;

/**
 * Use a filter table change event listener
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the table
 * @param table The table available for filtering or null to remove the table for the sourceId
 */
export var useFilterTableChangedListener = filterTableChangedFns.useListener;
var filterChangedFns = makeEventFunctions(InputFilterEvent.FILTERS_CHANGED);

/**
 * Listen for filter changes
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the filter
 * @param filterChange The filter change event or null to remove the filter for the sourceId
 */
export var listenForFilterChanged = filterChangedFns.listen;

/**
 * Emit a filter change event
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the filter
 * @param filterChange The filter change event or null to remove the filter for the sourceId
 */
export var emitFilterChanged = filterChangedFns.emit;

/**
 * Use a filter change event listener
 * @param eventEmitter The event emitter to emit the event on
 * @param sourceId The source ID for the filter
 * @param filterChange The filter change event or null to remove the filter for the sourceId
 */
export var useFilterChangedListener = filterChangedFns.useListener; // A panel or widget can have columns for filters
//# sourceMappingURL=FilterEvents.js.map